import {
  OrderStore,
  selectCurrentOrder,
} from '@des/store/order';
import {
  select,
  Store,
} from '@ngrx/store';
import {
  getOrderMainLastName,
} from '@refx/shared-common';
import {
  filter,
  map,
  take,
} from 'rxjs';

/**
 * Factory for the Plusgrade context provider in Booking.
 * Extracts PNR, last name, and point of sale from the current order.
 *
 * @param store the ngrx store
 * @returns a function that returns an observable of the Plusgrade context data
 */
export function createPlusgradeContextFactoryBooking(store: Store<OrderStore>) {
  return () => store.pipe(
    select(selectCurrentOrder),
    filter((order) => !!order),
    take(1),
    map((order) => {
      const pointOfSale = order.servicingPointOfSale?.countryCode || order.creationPointOfSale?.countryCode;
      return {
        pnr: order.id,
        lastName: getOrderMainLastName(order),
        pointOfSale,
        pnrBased: !!pointOfSale
      };
    })
  );
}
